import { z } from "zod";
import type { Address } from "viem";

const AddressSchema = z
  .string()
  .regex(/^0x[a-fA-F0-9]{40}$/) as z.ZodType<Address>;

export default AddressSchema;
